import React from 'react';
import Typography from '@material-ui/core/Typography';

const SettingsPage = () => {
  return <Typography variant="h5">Settings</Typography>;
};

export default SettingsPage;
